import React from 'react';
import styled from 'styled-components';
import EngagementScorePill from './EngagementScroePill';
import SideMenuIcon from 'assets/svgs/SideMenuIcon';
import { maxWidth, primaryColor, primaryFont, retina, statusBouncedColor, statusUnsubscribedColor, wMBold } from 'constants/utilsStyles';
import ContactCardPopover from '../Popovers/ContactCardPopover';
import { IContactItem } from 'modules/Audience/interface';
import { ContactStatusClass } from 'modules/Audience/constants';

const ContactCardFooterWrapper = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .status {
    font-family: ${primaryFont};
    font-weight: ${wMBold};
    font-size: 16px;
    line-height: 18px;
    color: ${primaryColor};
    margin-left: 20px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 14px;
      line-height: 16px;
    }
    &.hard-bounce {
      color: ${statusBouncedColor};
    }
    &.unsubscribed {
      color: ${statusUnsubscribedColor};
    }
  }
  .side-menu-div {
    cursor: pointer;
    .side-menu-icon {
      width: 20px; 
      height: 24px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        height: 20px;
      }
    }
  }
`;
type Props = {
  contact: IContactItem
  targetShow?: boolean;
  index?: number;
} & typeof defaultProps;

const defaultProps = {
  targetShow: false,
  index: null
};

const ContactCardFooterGlobal = function ContactCardFooterGlobal(props: Props) {
  const { contact: { contactId, status, engagementScore }, index, targetShow } = props;

  return (
    <ContactCardFooterWrapper className='contact-footer-wrapper'>
      <EngagementScorePill score={engagementScore} hide index={index} targetShow={targetShow} />
      <span className={`status ${ContactStatusClass[(status as string)]}`}>{status}</span>
      <div className='side-menu-div'>
        <ContactCardPopover toolTipShow contactId={contactId} targetShow={targetShow} index={index}>
          <SideMenuIcon width={'20'} />
        </ContactCardPopover>
      </div>
    </ContactCardFooterWrapper>
  );
};

ContactCardFooterGlobal.defaultProps = defaultProps;
export default ContactCardFooterGlobal;